import type { ChartData, ChartOptions } from "chart.js";

interface IGenerationChartOption {
  annualConst: any;
}

export function generationChartOption({
  annualConst
}: IGenerationChartOption): ChartOptions {
  const { annualDemandOriginal } = annualConst;

  return {
    animation: false,
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      title: {
        display: true,
        text: 'Annual Generation',
        color: 'rgba(255,255,255,0.88)',
        font: { size: 12 },
        padding: { bottom: 4 },
      },
      annotation: {
        annotations: {
          1: {
            type: "line",
            scaleID: "y",
            value: annualDemandOriginal,
            borderColor: "rgba(255,255,255,0.7)",
            borderWidth: 2,
            label: {
              backgroundColor: "rgba(0,35,60,0.9)",
              font: { size: 10, weight: "bold", family: "sans-serif" },
              color: "white",
              xPadding: 3,
              yPadding: 3,
              cornerRadius: 3,
              position: "center",
              enabled: true,
              content: "Demand"
            }
          }
        }
      }
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          offset: false,
          color: 'rgba(255,255,255,0.08)',
        },
      },
      y: {
        stacked: true,
        title: {
          display: true,
          text: 'Annual Generation & Demand (TWh)',
          padding: 0,
          font: { size: 10 },
          color: 'rgba(255,255,255,0.65)',
        },
        grid: { color: 'rgba(255,255,255,0.08)' },
      },
    },
  };
}
interface IGenerationChartData {
  allInputData: any;
  annualConst: any;
}
export function generationChartData({
  allInputData,
  annualConst
}: IGenerationChartData): ChartData {
  return {
    labels: ["Generation"],
    datasets: generateDatasets({ allInputData, annualConst })
  };
}

const generateDatasets = ({
  allInputData,
  annualConst
}: IGenerationChartData) => {
  let result = [];
  let index = 0;

  for (const technology of allInputData.technologyData) {
    if (technology.name !== "Blackout") {
      result.push({
        label: technology.name,
        borderWidth: 1,
        borderRadius: 3,
        order: 3,
        borderColor: technology.color,
        backgroundColor: technology.color,
        data: [annualConst.annualTechGen[index]]
      });
    }
    index++;
  }

  return result;
};
